import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperOverviewPage } from "./../shopper-overview/shopper-overview";
import { ShopperOverviewPlazamapPage } from "./../shopper-overview-plazamap/shopper-overview-plazamap";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-overview-plaza",
  templateUrl: "shopper-overview-plaza.html",
})
export class ShopperOverviewPlazaPage {
  lists: any;
  theme = 1;
  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaList;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.lists = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  select(id) {
    this.navCtrl.push(ShopperOverviewPlazamapPage, { plaza_id: id });
  }

  backPage() {
    this.navCtrl.push(ShopperOverviewPage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview-plaza/shopper-overview-plaza.ts